module.exports = __webpack_public_path__ + "static/media/intro.606c53a5.mp3";